module.exports = __webpack_public_path__ + "assets/294c8958be7b6465e8415ca8824b3944.svg";